import { EventEmitter } from "events"

export const appEvents = new EventEmitter()

export const APP_EVENTS = {
  CLOSE_BOTTOM_MENU: "CLOSE_BOTTOM_MENU",
} as const
